import React from "react";
import Label from "../../../../label";
import { MutedText } from "../../../../text";
import { getLocalizedProperty } from "../../../../../utils/i18n";
function HTMLComponent(param) {
    var row = param.row, allowHelpText = param.allowHelpText;
    var HTMLcontent = getLocalizedProperty(row, "control") || getLocalizedProperty(row, "options.defaultValue");
    var divRef = React.useRef(null);
    React.useEffect(function() {
        if (divRef.current) {
            var iframes = Array.from(divRef.current.querySelectorAll("iframe"));
            iframes.forEach(function(iframe) {
                if (iframe.height) {
                    iframe.style.height = iframe.height + "px";
                }
            });
        }
    }, [
        HTMLcontent,
        divRef.current
    ]);
    var helpText = allowHelpText ? row.description : "";
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Label, null, getLocalizedProperty(row, "label")), helpText && /*#__PURE__*/ React.createElement(MutedText, null, helpText), /*#__PURE__*/ React.createElement("div", {
        ref: divRef,
        dangerouslySetInnerHTML: {
            __html: HTMLcontent
        }
    }));
}
export default HTMLComponent;
